import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionBase } from '../session-base';
import { SessionsService } from '../sessions.service';
import { PluginsService } from '../../plugins/plugins.service';
import { merge, contains } from 'ramda/es';
import { FormBuilder, FormControl } from '@angular/forms';
import { ISession } from '../../../models/session';
import { TranslateService } from '@ngx-translate/core';
import { PhoneNumberService } from '../phone-number.service';
import { IPlugin } from '../../../models/plugin';
import { flatMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Component({
  templateUrl: './manage-my-event.component.html',
  styleUrls: ['./manage-my-event.component.scss']
})
export class SessionsManageMeEventComponent extends SessionBase implements OnInit {
  public sessionForm: any;
  public guestModeSessionTypes = ['interactive', 'mixte'];
  public showGuestMode: boolean = false;
  public showPhoneNumber: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private fb: FormBuilder,
    private sessionsService: SessionsService,
    private pluginsService: PluginsService,
    private phoneNumberService: PhoneNumberService
  ) {
    super();
    this.sessionForm = fb.group({
      guestMode: new FormControl(false)
    });
  }

  ngOnInit() {
    super.getSession(this.route.parent.data);

    const onError = message => err => {
      console.error(err);
      toastr.error(this.translateService.instant(message));
    };

    const onPlugins = (plugins: IPlugin[]) => {
      const smsPlugin = plugins.find(tag => tag.name === 'sms');
      this.showPhoneNumber = smsPlugin && smsPlugin.isActivated;
    };

    const getTags$ = (session: ISession) => this.pluginsService.getAll(session);

    const showGuestMode$ = (session: ISession) =>
      (this.showGuestMode = contains(session.types.sessionType, this.guestModeSessionTypes));

    of(this.session)
      .pipe(/*tap(showGuestMode$), */flatMap(getTags$), tap(onPlugins))
      .subscribe(null, onError('action.failed'));
  }

  bookNumber() {
    this.phoneNumberService.book(this.session).subscribe(
      number => {
        this.session.phoneNumber = number;
      },
      err => toastr.error(this.translateService.instant(err))
    );
  }

  isNotVOD() {
    if (!this.session || !this.session.types) {
      return true;
    }

    return this.session.types.sessionType !== 'vod';
  }

  doEdit() {
    const payload = merge(this.session, this.sessionForm.value);
    this.sessionsService.update(this.session.id, payload).subscribe((updatedSession: ISession) => {
      this.session = updatedSession;
      this.sessionsService.setComplete(this.session, 'manage_my_event');
    });
  }

  onCopySuccess(item: 'phone' | 'link') {
    const key = {
      phone: 'sessions.edit.phone_number.copied_success',
      link: 'sessions.edit.link.copied_success'
    }[item];
    toastr.success(this.translateService.instant(key));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/manage-my-event/manage-my-event.component.ts